import { createContext, useContext } from 'react';

/**
 * 화면 탭(게시판 #168, 10-09) — 열어 본 화면은 **숨겨 둔 채 살려 둔다**(레거시 버스인 MDI 탭처럼).
 * 재무추가에 입력하다 기준정보에서 차량을 찾고 돌아와도 입력·조건·스크롤이 그대로다.
 *
 * 숨은 화면도 effect 는 살아 있다 — 그래서 **창 전체에 거는 것**은 이 값으로 막아야 한다:
 *   - 창 전체 키보드(배차 Ctrl+C/V · 출납일보 Delete) — 안 막으면 보이지도 않는 화면의 줄이 지워진다.
 *   - 팝업(`Modal` 은 body 로 띄운다) — 안 막으면 숨은 화면의 팝업이 지금 화면 위에 뜬다.
 * 탭 밖(대시보드 위젯·껍데기)에서는 기본값 true.
 */
export const PageActiveContext = createContext(true);

export function usePageActive(): boolean {
  return useContext(PageActiveContext);
}
